import React from 'react'
import styled from 'styled-components'
import Select from 'react-select'
import ReactMarkdown from 'react-markdown'
import { Field } from 'formik'
import PropTypes from 'prop-types'

const ItemDescription = styled.div`
    max-width: 300px;
    p {
        font-style: italic;
        font-size: 14px;
    }
`

const ItemHeader = styled.option`
    font-weight: bold;
    padding-bottom: 0.5em;
`

const ItemWrapper = styled.div`
    padding-top: 2em;
    display: none;

    &.active {
        display: block;
    }
`

const DropdownComponent = styled(Field)`
    width: 300px;
    height: 32px;
    border-radius: 0px;
    border: 0;
    background-color: white;
    font-size: 16px;
    border-style: solid;
    border-width: 1px;
    border-color: rgb(230, 232, 237);
    }

    .styled__control {
        border-radius: 0px;
        border-color: ${props => props.theme.colors.inputLightGrey};

        &.styled__control--is-focused {
            border-color: ${props => props.theme.colors.inputLightGrey};
            box-shadow: 0 0 0 1px ${props => props.theme.colors.inputLightGrey};
        }
    }

    .styled__menu {
        border-radius: 0px;
        .styled__option--is-selected, .styled__option--is-focused{
            background-color: ${props => props.theme.colors.darkGreen};
            color: white;
        }
    }

    &:focus {
        outline: none;
        box-shadow: 0px 1px ${props => props.theme.colors.lightGrey};
    }
`

const InputHeader = styled.h3`
    margin-bottom: 0.5em;
    font-weight: bold;
`

const Wrapper = styled.div`
    padding-bottom: 3em;
`

class Dropdown extends React.Component {

    render() {

        const {
            data,
            values,
            setFieldValue,
        } = this.props

        const {
            description,
            dropdownSelections,
            integrationObjectName,
            required,
            header,
            placeholder
        } = data

        const dropdownSelectionIndex = () => {
            return dropdownSelections.findIndex(selection => selection.value === values[integrationObjectName])
        }

        return(
            <Wrapper>
                <InputHeader>
                    {header} {required && required === true && '*'}
                </InputHeader>
                {description &&
                    <>
                        {description.description}
                    </>
                }

                <DropdownComponent
                    //key prop is to force re-rendering when dropdown is reset
                    key={`select_key_${values[integrationObjectName]}`}
                    name={integrationObjectName}
                    options={dropdownSelections}
                    component={Select}
                    onChange={(e) => {
                        setFieldValue(integrationObjectName, e.value)
                    }}
                    getOptionLabel={option => option['header']}
                    placeholder={placeholder}
                    value={dropdownSelections[dropdownSelectionIndex()]}
                />

            </Wrapper>
        )
    }
}

Dropdown.propTypes = {
    data: PropTypes.object,
    values: PropTypes.object,
    setFieldValue: PropTypes.func
}

export default Dropdown